/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
const React = require('react');
const PropTypes = require('prop-types');
const Button = require('@andes/button');
const HomeRevampImage = require('./images/HomeRevampImage');
const { getEventTracker } = require('../../../../../../utils/event-tracker');

function HomeBanner(props) {
  const { i18n, siteId } = props;
  const Tracker = getEventTracker();
  const eventHour = siteId.match(/^(MLA|MLB|MLU)$/) ? '18' : siteId.match(/^(MLC)$/) ? '17' : '16';

  return (
    <div className="home-static-banner">
      <div className="home-static-banner-content">

        <div className="home-static-banner-text">
          <div className="home-static-banner-text__title">
            <h1>{i18n.gettext('¡Se vienen novedades!')}</h1>
          </div>

          <div className="home-static-banner-text__detail">
            <p>{i18n.gettext('El 20/abr., a las {0}h, presentaremos la nueva experiencia de Mercado Pago Developers. Inscríbete grátis y participa por premios.', eventHour)}</p>
          </div>

          <div className="home-static-banner-button">
            <Button
              target="_blank"
              href="https://docs.google.com/forms/d/17BYA0vTk59qJSXuVy80VbAysH5hKIbogJtbTvS7SEFk"
              onClick={() => { Tracker.send('mpdevelopers/click_dev_talks_inscription_intention'); }}
            >
              {i18n.gettext('Inscribirse en el evento')}
            </Button>
          </div>
        </div>

        <div className="home-static-banner-image">
          <HomeRevampImage />
        </div>
      </div>
    </div>
  );
}

HomeBanner.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  siteId: PropTypes.func.isRequired,
};

HomeBanner.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = HomeBanner;
